import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import { styled } from "@mui/material/styles";
import ComponentWrapper from "../ComponentWrapper/ComponentWrapper.js";
import Text from "../Text/Text.js";
import TrendWithIcon from "../Trend/WithIcon.js";
import Value from "../Value/Value.js";
function shouldForwardProp(prop) {
  return !["withScroll"].includes(prop);
}
const Template = styled("div", {
  shouldForwardProp
})(({
  theme
}) => ({
  display: "flex",
  padding: theme.sizes.spacing["07"],
  flexDirection: "column",
  gap: theme.sizes.spacing["11"],
  flex: "1 0 0",
  alignSelf: "stretch",
  overflow: "hidden",
  justifyContent: "space-between",
  ".card-container &": {
    height: `${2 * theme.sizes.grid.height}rem`,
    border: "5px solid red"
  },
  "& .text-and-value": {
    gap: theme.sizes.spacing["02"]
  },
  "& .text-and-value .text-with-help": {
    "& .MuiTypography-h6": {
      color: theme.colors.text.tertiary
    }
  },
  "& .value": {},
  "& .value-with-trend-indicator": {}
}));
const ValueWithTrendTemplate = (t0) => {
  const $ = c(17);
  const {
    title,
    comparison,
    original,
    format,
    isLoading: t1,
    noComparison: t2,
    helpContent
  } = t0;
  const isLoading = t1 === void 0 ? false : t1;
  const noComparison = t2 === void 0 ? false : t2;
  let t3;
  if ($[0] !== helpContent || $[1] !== title) {
    t3 = title && /* @__PURE__ */ jsx(ComponentWrapper, { className: "text-with-help", children: /* @__PURE__ */ jsx(Text, { variant: title.variant || "h6", text: `${title.text}`, helpContent, help: title.help ? title.help : null }) });
    $[0] = helpContent;
    $[1] = title;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== format || $[4] !== isLoading || $[5] !== original) {
    t4 = /* @__PURE__ */ jsx(ComponentWrapper, { className: "value", children: /* @__PURE__ */ jsx(Value, { data: original, format, isLoading, float: "left" }) });
    $[3] = format;
    $[4] = isLoading;
    $[5] = original;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = /* @__PURE__ */ jsxs(ComponentWrapper, { className: "text-and-value", children: [
      t3,
      t4
    ] });
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== comparison || $[11] !== isLoading || $[12] !== noComparison) {
    t6 = !noComparison && /* @__PURE__ */ jsx(ComponentWrapper, { className: "value-with-trend-indicator", children: /* @__PURE__ */ jsx(TrendWithIcon, { data: comparison, isLoading }) });
    $[10] = comparison;
    $[11] = isLoading;
    $[12] = noComparison;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t5 || $[15] !== t6) {
    t7 = /* @__PURE__ */ jsxs(Template, { children: [
      t5,
      t6
    ] });
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};
export {
  ValueWithTrendTemplate as default
};
